import { render } from "./PostpaidQA.vue?vue&type=template&id=a9b9fa78&scoped=true"
import script from "./PostpaidQA.vue?vue&type=script&lang=js"
export * from "./PostpaidQA.vue?vue&type=script&lang=js"

import "./PostpaidQA.vue?vue&type=style&index=0&id=a9b9fa78&scoped=true&lang=css"

import exportComponent from "D:\\Nomura\\PROJECT\\010.Src_By_SYSLAB\\007.MCSC_Web\\Git_main\\FrontEnd\\site\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a9b9fa78"]])

export default __exports__